import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BedService } from 'src/app/bed-management/bed.service';
import Swal from 'sweetalert2';
import { DiagnosticserviceService } from '../diagnosticservice.service';


@Component({
  selector: 'app-add-diagnostic',
  templateUrl: './add-diagnostic.component.html',
  styleUrls: ['./add-diagnostic.component.scss']
})
export class AddDiagnosticComponent {
  form: FormGroup;
  editForm: FormGroup;
  breadCrumbItems: any;
  data: any;
  id: any;
  typesubmit: boolean;
  roomdata: any;
  today: Date;
  now: string;


  constructor(public formBuilder: UntypedFormBuilder, private myservice: DiagnosticserviceService, public route: ActivatedRoute, private router: Router, public datePipe: DatePipe, public modalService: NgbModal) {
    this.form = this.formBuilder.group({
      
      diagnostic_date: new FormControl(
        new Date().toISOString().substring(0, 10)
      ),
      diagnostic_name: ['', Validators.required],
      diagnostic_amount: ['', Validators.required],
   
    })
    this.editForm = this.formBuilder.group({
      diagnostic_date: ['', Validators.required],
      diagnostic_name: ['', Validators.required],
      diagnostic_amount: ['', Validators.required],
    })

    this.today = new Date();
    this.now = datePipe.transform(new Date(), 'yyyy-MM-dd');

  }

  ngOnInit(): void {
    this.breadCrumbItems = [{ label: 'Godavari wave Tech' }, { label: 'Add - Diagnostic Tests ', active: true }];
    this.getdiagnostics();
  }

  gotoassigntest() {
    this.router.navigate(['/diagnostic/assign-diagnostic']);
  }

  reset() {
    this.form.reset()
  }

  
  typeSubmit() {
    if (this.form.invalid) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Please Fill the Empty Field',
        showConfirmButton: false,
        timer: 1500
      })
    } else {

      // this.form.value.company_id = localStorage.getItem('company_id');
      const companyId = localStorage.getItem('company_id');
      console.log('company_id from localStorage:', companyId); // Debugging step
      this.form.value.company_id = companyId;


      this.myservice.adddiagnostics(this.form.value).subscribe((res: any) => {
        if (res.status == 200) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Successfully Test Added',
            showConfirmButton: false,
            timer: 1500
          });
          this.getdiagnostics();
          this.form.reset();

        } else {
          Swal.fire('Failed');
        }
      });
    }
  }

  getdiagnostics() {
    this.myservice.getdiagnostics().subscribe((res: any) => {
      this.data = res.data;
    });
  }

  centerModal(centerDataModal: any, data) {
    console.log(data);
    
    this.editForm.patchValue({
      diagnostic_date: data.diagnostic_date,
      diagnostic_name: data.diagnostic_name,
      diagnostic_amount: data.diagnostic_amount,
     
      id: data.id,
    });
    this.id = data.id;
    this.modalService.open(centerDataModal, { centered: true, size: "lg" });
  }

  edit() {
    this.typesubmit = true;
    if (this.editForm.invalid) {
      alert("Please fill all details")
    } else
      var data = {
        company_id: localStorage.getItem("company_id"),
        id: this.id,
        diagnostic_date: this.editForm.value.diagnostic_date,
        diagnostic_name: this.editForm.value.diagnostic_name,
        diagnostic_amount: this.editForm.value.diagnostic_amount,
      
      };

    this.myservice.editdiagnostics(data).subscribe((res: any) => {
      if (res.status == 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Successfully Updated",
          showConfirmButton: false,
          timer: 1500,
        });
        this.typesubmit = false;
        this.editForm.reset();
        this.modalService.dismissAll();
        this.getdiagnostics();
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Oops...",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  }

  Delete(i) {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure to delete it ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.myservice.deletediagnostics(i).subscribe((res: any) => {
          if (res.status == 200) {
           this.getdiagnostics();
            ;
            Swal.fire({
              position: "top-end",
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success",
            });
          }
        });
      }
    });
  }
}
